// extracted by mini-css-extract-plugin
export default {"form-pages":"styles__form-pages--7N+5q","form-page":"styles__form-page--64tlT","large":"styles__large--dedHO","hidden":"styles__hidden--UqZhb"};